import React from 'react';
import PropTypes from 'prop-types';
import { UserProvider, SubscriptionsProvider } from '@adsk/alloy-provider';
import { LocaleProvider } from '@adsk/alloy-react-locale';
import { Reset } from '@adsk/alloy-react-theme';
import ConnectedTopNavigationOptionalUser from './ConnectedTopNavigationOptionalUser';
import TopNavigationLayout from './TopNavigationLayout';

/**
 * PublicPageLayout component is the root component to show a page view for both logged in and logged out users.
 * This component should be used for public links, where the user may or may not be logged in.
 * This component **would not redirect** the user to login page if the user is not logged in.
 */
const PublicPageLayout = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    children,
    onLogout,
    locale,
    renderAboveLayout
  } = _ref;
  return /*#__PURE__*/React.createElement(LocaleProvider, {
    locale: locale
  }, /*#__PURE__*/React.createElement(Reset, null), /*#__PURE__*/React.createElement(UserProvider, {
    redirectLoggedOutUsers: false
  }, /*#__PURE__*/React.createElement(SubscriptionsProvider, null, /*#__PURE__*/React.createElement(TopNavigationLayout, {
    ref: ref,
    renderTopNavigation: () => /*#__PURE__*/React.createElement(ConnectedTopNavigationOptionalUser, {
      onLogout: onLogout
    }),
    renderAboveLayout: renderAboveLayout
  }, children))));
});
PublicPageLayout.displayName = 'PublicPageLayout';
PublicPageLayout.propTypes = {
  /** Page content */
  children: PropTypes.node,
  /** callback called on logout */
  onLogout: PropTypes.func,
  /** localization, default: en */
  locale: PropTypes.string,
  /** Items that will render above the layout*/
  renderAboveLayout: PropTypes.func
};
export default PublicPageLayout;
//# sourceMappingURL=PublicPageLayout.js.map